<div class="row">
    <div class="col-lg-8 mx-auto mb-4">
        <ul class="nav nav-tabs border-0 rounded-pill bg-white my-4">
            <li class="nav-item w-50 m-0">
                <a class="nav-link text-center font-weight-bold text-uppercase" routerLink="current" routerLinkActive="active">Current Orders</a>
            </li>
            <li class="nav-item w-50 m-0">
                <a class="nav-link text-center font-weight-bold text-uppercase" routerLink="previous" routerLinkActive="active">Previous Orders</a>
            </li>
        </ul>
    </div>
</div>


<router-outlet></router-outlet>